import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: '#E5B611', // Brand color
    },
    secondary: {
      main: '#518AF4', // Complementary / Secondary color
    },
    background: {
      default: '#F5F4F7', // BG color
      white: '#FFFFFF', // White color
      black: '#000000', // Black color  
    },
    text: {
      primary: '#FFFFFF', // Text active
      primaryDark: '#000000', // Text active dark
      secondary: '#667085', // Text inactive
      disabled: '#FAF9F6', // Disabled text
    },
    navbar: {
      main: '#FFFFFF', // Navbar color
      mainDark: '#0B0B0B', // Navbar color dark
    },
  },

  
});

export default theme;